module.exports = __webpack_public_path__ + "img/logo.c0280d00.png";